import FuelGeofencingZipcodes from './FuelGeofencingZipcodes';
export default FuelGeofencingZipcodes;
